var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionAccordion',{attrs:{"id":"SectionOpenPositions"}},[_c('Wrap',[_c('SectionTitle',{attrs:{"title":_vm.$t('open')}},[_c('Field',{staticClass:"countries",attrs:{"options":[
          [null, _vm.$t('allCountries')],
          ..._vm.countries,
        ],"type":"select","value":_vm.activeCountry},on:{"update:value":function($event){_vm.activeCountry=$event}}})],1),_c('div',{attrs:{"id":"open-positions"}},[(!_vm.jobs.length)?_c('Empty',[_vm._v(" "+_vm._s(_vm.$t('none'))+" ")]):_vm._l((_vm.jobs),function(job){return _c('OpenPosition',{key:job.id,attrs:{"job":job}})})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }